import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import {css, Global} from "@emotion/react";
import Typography from "@mui/material/Typography";
import Cancel from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import {Theme} from "@mui/system";
import SelectSettings from "./SelectSettings";
import ZoomSettings from "./ZoomSettings";
import PayComp from "./Pay";
import DialogComp from "./DialogComponent";

interface ImageInterface {
  src: string,
  width: number,
  height: number
}

export const texts = [<>
  <Typography
    sx={{mb: 2}}>{"Цель — собрать в экспозиции мемориального дома-музея художника произведения трех талантливых\n" +
  "представителей семьи Шишкиных. На сегодня имеется:"}</Typography>
  <Typography sx={{mb: 2}}>{
    "От Ивана Ивановича Шишкина — экспонируются 5 работ и 60 офортов."}</Typography>
  <Typography sx={{mb: 2}}>{
    "От Ольги Лагоды-Шишкиной — 1 живописная картина и альбом из 50 рисунков.\n"}</Typography>
  <Typography sx={{mb: 2}}>{
    "От Ксении Ивановны Шишкиной — музей пока обладает лишь акварельной открыткой."}</Typography>
  <Typography sx={{mb: 2}}>{
    "Живописное полотно Ксении Шишкиной «В теплице», датированное 1910 г., сейчас находится в\n" +
    "частной коллекции реставратора и искусствоведа Алексея Маркова из Санкт-Петербурга.\n" +
    "Коллекционер готов продать картину музею, который желает продемонстрировать ее всем гостям\n" +
    "города Елабуга.\n"}</Typography>
  <Typography sx={{mb: 2}}>{
    "Ксения Шишкина - дочь Ивана Шишкина и Ольги Лагоды. О ее судьбе известно немного - родилась она\n" +
    "в 1881 году, росла без матери, которая умерла вскоре после ее рождения, художественному\n" +
    "мастерству училась у отца, после революции уехала жить в Финляндию к своей сводной сестре -\n" +
    "дочери Шишкина от первого брака. В 1937 году обратилась в посольство СССР с просьбой разрешить\n" +
    "ей въезд в страну, а что было дальше, неизвестно. Как неизвестны ни дата, ни место смерти Ксении\n" +
    "Шишкиной. Несмотря на то, что имя Ксении Шишкиной внесено в Реестр профессиональных\n" +
    "художников Российской империи, СССР, «русского зарубежья», Российской Федерации и республик\n" +
    "бывшего Советского Союза, сведений о ее работах крайне мало."}</Typography></>,


  <><Typography
    sx={{mb: 2}}>{"Вся картина разделена на 4 400 ячеек. За каждой ячейкой установлена сумма жертвования в размере " +
  "500 рублей. Выбирая нужное количество ячеек, сумма автоматически увеличивается. \n"}</Typography>
    <Typography sx={{mb: 2}}>Для удобства вы можете увеличить размер поля выделяемых ячеек (РАЗМЕР ВЫДЕЛЯЕМОЙ ЯЧЕЙКИ)
      которая находится под картиной до 4-х (сумма составит 2000 руб.) или до 9-ти ячеек (сумма составит
      4500 руб.). </Typography>
    <Typography sx={{mb: 2}}>Также есть возможность увеличить картину (УВЕЛИЧИТЬ ИЗОБРАЖЕНИЕ) для более точного
      выделения последовательности ячеек. </Typography>
    <Typography sx={{mb: 2}}>Кнопка СБРОСИТЬ – автоматически сбрасывает все выделенные ячейки</Typography>
    <Typography sx={{mb: 2}}>Жертвователь – физическое лицо выбравшее определенное количество ячеек за которые произвел
      перевод на проекты АМТГ по сохранению наследия малых городов.</Typography>
    <Typography sx={{mb: 2}}>Ваше имя в истории – если вы пожелаете, чтобы ваше имя попало в открытый список
      благодарности,
      то просим указать ФИО и установить галочку в специальном поле. Ваше ФИО будет опубликовано на
      сайте сбора средств, а также указано в перечне жертвователей на отдельном документе при
      экспозиции картины. </Typography>
  </>,

  <><Typography sx={{mb: 2}}>{"Общая собранная сумма составляет 2 200 000 рублей и состоит она из:\n"}</Typography>

    <Typography sx={{mb: 2}}><b>1.</b>Стоимость самой картины – 2 000 000 руб.</Typography>
    <Typography sx={{mb: 2}}>
      <b>2.</b> Эквайринг – банковская система перевода средств с помощью банковской карты 2% (44 000)</Typography>
    <Typography sx={{mb: 2}}><b>3.</b> Работа бухгалтера по обработке принятых платежей, подготовка документов
      финансовой отчётности в налоговую в размере 60 000 руб.</Typography>
    <Typography sx={{mb: 2}}>
      <b>4.</b> Для ускорения сбора средств и выкупа картины - 50 000 руб. (продвижение проекта)</Typography>
    <Typography sx={{mb: 2}}><b>5.</b> Средства на поддержку работы сайта и платежной системы в размере 46 000
      рублей</Typography></>,

  <Box dangerouslySetInnerHTML={{
    __html: "<div>\n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPS-BoldMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPS-BoldMT;color:black;mso-font-kerning:0pt'>Договор\n" +
      "о добровольном пожертвовании (публичная оферта)</span></b></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPS-BoldMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPS-BoldMT;color:black;mso-font-kerning:0pt'>г. Углич<span\n" +
      "        style='mso-spacerun:yes'>                                                                                                                         \n" +
      "</span><span><span style='mso-spacerun:yes'>   </span>«</span>15»\n" +
      "мая 2023 г.</span></b></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>Некоммерческое объединение\n" +
      "«Ассоциация малых туристских городов» (НО «АМТГ»), в лице Директора – Анучина\n" +
      "Константина Вячеславовича привлечении средств под </span><span\n" +
      "        style='font-size:12.0pt;mso-bidi-font-family:TimesNewRomanPSMT;color:black;\n" +
      "mso-font-kerning:0pt'>уставную деятельность и программы</span><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'> для городов-членов\n" +
      "Ассоциации. Акцепт Публичной оферты означает ознакомление, понимание всех\n" +
      "вместе и каждого в отдельности условий Публичной оферты, полное, безусловное и\n" +
      "безоговорочное согласие жертвователя с положениями настоящей оферты.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPS-BoldMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPS-BoldMT;color:black;mso-font-kerning:0pt'>Сайт </span></b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>– официальный веб-портал Ассоциации,\n" +
      "расположенный в сети Интернет по адресу </span><span ><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;mso-font-kerning:0pt'><a href=\"https://amtg-rus.ru/\">https://amtg-rus.ru/</a></span></span><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPS-BoldMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPS-BoldMT;color:black;mso-font-kerning:0pt'>1.\n" +
      "Общие положения о публичной оферте</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.1. Данное предложение\n" +
      "является публичной офертой в соответствии с пунктом 2 статьи 437 Гражданского\n" +
      "Кодекса РФ.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.2. Акцепт данного\n" +
      "предложения жертвователем означает, что последний ознакомился и согласен со\n" +
      "всеми условиями настоящего Договора о добровольном пожертвовании с Ассоциацией.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.3. Оферта вступает в силу\n" +
      "со дня, следующего за днем ее публикации Сайте.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.4. Ассоциация вправе в\n" +
      "любой момент в одностороннем порядке изменять текст настоящего Договора\n" +
      "посредством публикации его новой редакции на Сайте. По этой причине жертвователь\n" +
      "обязан не реже чем один раз в две недели посещать Сайт для ознакомления с\n" +
      "актуальным текстом Договора. Если в течение 5 (пяти) календарных дней со дня\n" +
      "публикации изменений оферты жертвователь не выслал Ассоциации уведомление о\n" +
      "том, что он не согласен с ее изменениями, в связи с чем в одностороннем порядке\n" +
      "расторгает его, будет считаться, что жертвователь согласен со всеми изменениями\n" +
      "настоящей оферты.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.5. Оферта является\n" +
      "бессрочной и действует до дня, следующего за днем размещения на Сайте извещения\n" +
      "об отмене Оферты. Ассоциация вправе отменить Оферту в любое время без\n" +
      "объяснения причин.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.6. Недействительность\n" +
      "одного или нескольких условий Оферты не влечет недействительности всех\n" +
      "остальных условий Оферты.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.7. Принимая условия\n" +
      "данного соглашения, жертвователь подтверждает добровольный и безвозмездный\n" +
      "характер пожертвования.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>1.8. Ассоциация готова заключать\n" +
      "договоры пожертвования в ином порядке и (или) на иных условиях, не\n" +
      "предусмотренных настоящим Договором, для чего любое заинтересованное лицо\n" +
      "вправе обратиться для заключения соответствующего договора к Ассоциации.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPS-BoldMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPS-BoldMT;color:black;mso-font-kerning:0pt'>2.\n" +
      "Предмет договора</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>2.1. По настоящему договору\n" +
      "жертвователь в качестве добровольного пожертвования перечисляет собственные\n" +
      "денежные средства на расчетный счет Ассоциации, а Ассоциация принимает\n" +
      "пожертвование и использует на уставные цели и конкретные программы.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>2.2. Выполнение жертвователем\n" +
      "действий по настоящему договору является пожертвованием в соответствии со\n" +
      "статьей 582 Гражданского кодекса РФ.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPS-BoldMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPS-BoldMT;color:black;mso-font-kerning:0pt'>3.\n" +
      "Деятельность Ассоциации</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>3.1. Целью деятельности Ассоциации\n" +
      "является сохранение культуры, традиций, ремесел на территории малых и средних\n" +
      "городов с большим историческим прошлым входящих в Ассоциацию малых туристских\n" +
      "городов. Ассоциация осуществляет культурно-просветительскую деятельность,\n" +
      "общественные кампании, сохранению объектов культурного и архитектурного\n" +
      "наследия, как включенных в перечень ОКН, так и объектов являющимся\n" +
      "историческими по мнению членов Ассоциации. Ассоциация содействует в сборе\n" +
      "средств на приобретение, реставрацию, консервацию объектов, несущих\n" +
      "историческую ценность для территории. </span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>3.2. Ассоциация ведет деятельность\n" +
      "в соответствии с действующим законодательством РФ.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>3.3. Ассоциация публикует\n" +
      "информацию о своей работе, целях и задачах, мероприятиях и результатах на\n" +
      "Сайте, в печатных и электронных изданиях Ассоциации и в других открытых\n" +
      "источниках.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>3.4. Жертвователь может\n" +
      "ознакомиться с Уставом Ассоциации </span><span ><b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;mso-font-kerning:0pt'><a\n" +
      "        href=\"https://amtg-rus.ru/about/ustav/\">здесь</a></span></b></span><b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:#1155CD;mso-font-kerning:0pt'> </span></b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>3.5. Жертвователь может\n" +
      "ознакомиться с отчетностью Ассоциации на странице: </span><span\n" +
      "        ><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;mso-font-kerning:0pt'><a\n" +
      "        href=\"https://amtg-rus.ru/\">https://amtg-rus.ru/</a></span></span><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>3.6. Жертвователь может\n" +
      "ознакомиться с актуальным списком программ Ассоциации, в т.ч. для осуществления\n" +
      "целевого пожертвования, </span><span ><b><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;mso-font-kerning:0pt'><a href=\"https://amtg-rus.ru/projects/\">здесь</a></span></b></span><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>4.\n" +
      "Акцепт оферты</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>4.1. Акцептовать Оферту и\n" +
      "тем самым заключить с Ассоциацией Договор может физическое лицо.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>4.2. Датой акцепта Оферты\n" +
      "является совершение пожертвования, а именно дата зачисления денежных средств на\n" +
      "расчетный счет Ассоциации.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>4.3. Местом заключения\n" +
      "Договора считается город Углич Российской Федерации. В соответствии с пунктом 3\n" +
      "статьи 434 Гражданского кодекса Российской Федерации Договор считается\n" +
      "заключенным в письменной форме.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>4.4. Условия Договора\n" +
      "определяются Офертой в редакции (с учетом изменений и дополнений), действующей\n" +
      "(действующих) на день оформления платежного распоряжения.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>4.5. Стороны установили,\n" +
      "что изготовление настоящего Договора на бумажном носителе не требуется, а факт\n" +
      "оплаты является согласием с условиями настоящего Договора.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.\n" +
      "Внесение пожертвования</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.1. Жертвователь\n" +
      "самостоятельно определяет размер суммы добровольного пожертвования и\n" +
      "перечисляет его Ассоциации методом, указанным на Сайте или иными методами на\n" +
      "условиях настоящего Договора, в том числе путем перечисления денежных средств\n" +
      "платежным поручением по реквизитам Ассоциации, указанным в настоящем договоре,\n" +
      "с указанием в строке «Назначение платежа»: «Пожертвование на уставные цели и\n" +
      "программы АМТГ».</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.2. Жертвователь\n" +
      "осуществляет добровольное пожертвование путем оформления поручения списание\n" +
      "пожертвования с банковской карты.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.3. Пожертвования,\n" +
      "полученные на уставную деятельность, либо полученные Ассоциаций без указания\n" +
      "конкретного назначения, направляются на реализацию уставных целей и проектов\n" +
      "Ассоциации, исходя из важности и степени срочности, с которой необходимо\n" +
      "оказать содействие программе.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.4. Ассоциацией не\n" +
      "осуществляется сбор никаких дополнительных комиссий с пожертвований,\n" +
      "перечисляемых жертвователем. Ассоциация уведомляет жертвователя о том, что\n" +
      "комиссия может взиматься банковскими организациями, платежными системами,\n" +
      "операторами приема платежей. При осуществлении пожертвования все расходы за\n" +
      "перевод денежных средств полностью возлагаются на жертвователя. Ассоциация\n" +
      "берет на себя погашение эквайринга при перечислении средств по карте на\n" +
      "программу.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.5. Ассоциация в рамках\n" +
      "своей деятельности вправе размещать на Сайте, в группах в</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>социальных сетях отчетную\n" +
      "информацию о суммах поступивших пожертвований, их целевом использовании (в том\n" +
      "числе в рамках конкретных благотворительных программ), иную информацию,\n" +
      "связанную с деятельностью Ассоциации и направленную на достижение его целей.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>5.6. Пожертвование может\n" +
      "быть использовано Ассоциацией на цели и программы в течение неограниченного\n" +
      "периода времени с момента получения Ассоциацией добровольного пожертвования.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.\n" +
      "Права и обязанности сторон</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.1. Ассоциация обязуется\n" +
      "использовать полученные от жертвователя по настоящему договору денежные\n" +
      "средства строго в соответствии с действующим законодательством РФ в рамках\n" +
      "уставной деятельности и программ.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.2. При получении\n" +
      "пожертвования на программы, Ассоциация использует это пожертвование по\n" +
      "назначению, самостоятельно конкретизируя его использование в рамках программ,\n" +
      "исходя из статей ее бюджета. Если сумма пожертвования превысит необходимую, Ассоциация\n" +
      "по-своему усмотрению распределяет оставшиеся денежные средства на уставные цели,\n" +
      "в том числе на другие программы.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.3. Полученное от жертвователя\n" +
      "пожертвование, по причине закрытия потребности частично или полностью и не\n" +
      "израсходованное согласно назначению, указанному жертвователем в платежном\n" +
      "поручении, не возвращается жертвователю, а перераспределяется Ассоциацией\n" +
      "самостоятельно на другие актуальные программы.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.4. Ассоциация вправе\n" +
      "осуществлять рассылку жертвователям сообщений (в том числе по электронной почте,\n" +
      "SMS, через используемые Ассоциацией социальные сети и т.п.) о текущих\n" +
      "программах и иных сообщений информационного характера.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.5. По запросу жертвователя\n" +
      "(в т.ч. в виде электронного письма) Ассоциация обязана предоставить жертвователю\n" +
      "информацию о сделанных жертвователем пожертвованиях.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.6. Ассоциация не несет\n" +
      "перед жертвователем иных обязательств, кроме обязательств, указанных в\n" +
      "настоящем Договоре.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.7. Жертвователь обязан\n" +
      "указывать достоверную персональную и контактную информацию при оформлении\n" +
      "поручения в случае регулярного (ежемесячное) списание пожертвования с\n" +
      "банковской карты (<span >автоплатеж</span>), гарантируя Ассоциации\n" +
      "достоверность и принадлежность исключительно Ассоциации указываемых данных,\n" +
      "включая реквизиты банковской карты, <span >email</span>, номер\n" +
      "телефона.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.7.1. Ассоциация не несет\n" +
      "ответственности перед жертвователем, если вследствие указания недостоверных\n" +
      "персональных и контактных данных жертвователем при оформлении заявки на\n" +
      "добровольное пожертвование, жертвователю не будет приходить подтверждающая\n" +
      "информация о внесенных добровольных пожертвованиях, а также инструкция для\n" +
      "отмены пожертвования.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>6.8. Ассоциация не\n" +
      "гарантирует корректную работу почтовых сервисов <span >ертвователя</span>\n" +
      "по своевременному получению отправленных сообщений. В случае, если почтовый\n" +
      "сервис жертвователя идентифицирует сообщения Ассоциации как &quot;спам&quot;,\n" +
      "        &quot;рассылка&quot; или в случае, если жертвователь по какой-то причине\n" +
      "отказался (отписался) от сообщений Ассоциации, ответственность за их получение\n" +
      "лежит на жертвователе.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>7.\n" +
      "Персональные данные</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>7.1. Жертвователь дает\n" +
      "согласие на обработку предоставленных Ассоциации при осуществлении\n" +
      "добровольного пожертвования персональных данных (ФИО, адрес, местожительства,\n" +
      "адрес электронной почты, банковские реквизиты, иные данные), в том числе третьим\n" +
      "лицам (на основании договора с жертвователем), для целей исполнения</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>настоящего договора,\n" +
      "включая следующие действия: сбор, запись, систематизацию, накопление, хранение,\n" +
      "уточнение (обновление, изменение), извлечение, использование, передачу (распространение,\n" +
      "предоставление, доступ), обезличивание, блокирование, удаление, уничтожение\n" +
      "персональных данных.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>7.2. Жертвователь обязуется\n" +
      "ознакомиться с Политикой конфиденциальности Ассоциации.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>7.3. Ассоциация обязуется\n" +
      "не раскрывать третьим лицам личную и контактную информацию жертвователя без его\n" +
      "письменного согласия, за исключением случаев указанных в п.7.1. и требования\n" +
      "данной информации государственными органами, имеющими полномочия требовать\n" +
      "такую информацию.</span></p>\n" +
      "\n" +
      "      \n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>8.\n" +
      "Отмена пожертвования</span></b></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>8.1. Жертвователь имеет\n" +
      "право отменить передачу пожертвования путем направления письменного\n" +
      "(электронного) требования Ассоциации в случае, если пожертвование использовано\n" +
      "для какой-либо цели, отличной от допускаемой по настоящему Договору. В этом\n" +
      "случае сумма пожертвования (вся или ее соответствующая часть) должна быть возвращена\n" +
      "жертвователю в срок, не позднее 30 (тридцати) календарных дней с момента получения\n" +
      "Ассоциацией соответствующего требования.</span></p>\n" +
      "\n" +
      "      <p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>8.2. Жертвователь имеет\n" +
      "право отменить внесение пожертвований, осуществляемых посредством <span\n" +
      "          >автоплатежа</span>. Уведомление об отмене внесения пожертвований, осуществляемых\n" +
      "посредством <span >автоплатежа</span> должно быть направлено Ассоциации\n" +
      "в срок, не менее чем за 15 (пятнадцать) календарных дней до даты очередного автоматического\n" +
      "списания. Уведомление должно содержать следующие данные: </span></p>\n" +
      "\n" +
      "      <p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "mso-add-space:auto;text-align:justify;text-indent:-18.0pt;line-height:normal;\n" +
      "mso-list:l0 level1 lfo1;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "        style='font-size:12.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;\n" +
      "        mso-bidi-font-family:Symbol;color:black;mso-font-kerning:0pt'><span\n" +
      "        style='mso-list:Ignore'>·<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
      "</span></span></span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "      mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>фамилия\n" +
      "      и имя, как указано на карте; </span></p>\n" +
      "\n" +
      "  <p style='margin-bottom:0cm;margin-bottom:\n" +
      ".0001pt;mso-add-space:auto;text-align:justify;text-indent:-18.0pt;line-height:\n" +
      "normal;mso-list:l0 level1 lfo1;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "    style='font-size:12.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;\n" +
      "    mso-bidi-font-family:Symbol;color:black;mso-font-kerning:0pt'><span\n" +
      "    style='mso-list:Ignore'>·<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
      "</span></span></span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>четыре\n" +
      "последних цифры карты, с которой осуществляется автоматическое списание\n" +
      "средств; </span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:\n" +
      ".0001pt;mso-add-space:auto;text-align:justify;text-indent:-18.0pt;line-height:\n" +
      "normal;mso-list:l0 level1 lfo1;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;\n" +
      "mso-bidi-font-family:Symbol;color:black;mso-font-kerning:0pt'><span\n" +
      "style='mso-list:Ignore'>·<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
      "</span></span></span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>электронный\n" +
      "адрес.</span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>8.3. Жертвователь имеет\n" +
      "право отменить последнее внесенное посредством <span >автоплатежа</span>\n" +
      "пожертвование. Заявление об отмене внесения пожертвования и возврате денежных средств,\n" +
      "должно быть направлено Ассоциации в срок, не позднее 5 (пяти) рабочих дней с\n" +
      "момента последнего очередного автоматического списания. Заявление должно содержать\n" +
      "следующие данные: </span></p>\n" +
      "\n" +
      "<p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "mso-add-space:auto;text-align:justify;text-indent:-18.0pt;line-height:normal;\n" +
      "mso-list:l1 level1 lfo2;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;\n" +
      "mso-bidi-font-family:Symbol;color:black;mso-font-kerning:0pt'><span\n" +
      "style='mso-list:Ignore'>·<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
      "</span></span></span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>фамилия\n" +
      "и имя; </span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:\n" +
      ".0001pt;mso-add-space:auto;text-align:justify;text-indent:-18.0pt;line-height:\n" +
      "normal;mso-list:l1 level1 lfo2;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;\n" +
      "mso-bidi-font-family:Symbol;color:black;mso-font-kerning:0pt'><span\n" +
      "style='mso-list:Ignore'>·<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
      "</span></span></span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>банковские\n" +
      "реквизиты для возврата денежных средств; </span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:\n" +
      ".0001pt;mso-add-space:auto;text-align:justify;text-indent:-18.0pt;line-height:\n" +
      "normal;mso-list:l1 level1 lfo2;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;\n" +
      "mso-bidi-font-family:Symbol;color:black;mso-font-kerning:0pt'><span\n" +
      "style='mso-list:Ignore'>·<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
      "</span></span></span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>электронный\n" +
      "адрес.</span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>Возврат денежных средств по\n" +
      "основанию, предусмотренному настоящим пунктом, осуществляется в течение 30\n" +
      "(тридцати) календарных дней с момента получения Ассоциацией соответствующего\n" +
      "заявления.</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>8.4. Ассоциация в любое\n" +
      "время до начала использования пожертвования вправе отказаться от пожертвования\n" +
      "без объяснения причин, при этом пожертвование возвращается жертвователю в\n" +
      "полном объеме.</span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>9. Прочие\n" +
      "условия</span></b></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>9.1. В случае возникновения\n" +
      "споров и разногласий между Сторонами по-настоящему договору, они будут по\n" +
      "возможности разрешаться путем переговоров. В случае невозможности разрешения\n" +
      "спора путем переговоров, споры и разногласия могут решаться в соответствии с\n" +
      "действующим законодательством Российской Федерации в судебных инстанциях по\n" +
      "месту нахождения Ассоциации.</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>9.2. Любые уведомления по\n" +
      "настоящему договору могут быть направлены в письменной форме, а равно путем\n" +
      "отправки электронного документа.</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>9.3. Совершая действия,\n" +
      "предусмотренные настоящей Офертой, жертвователь подтверждает, что ознакомлен с\n" +
      "условиями и текстом Оферты, целями деятельности Ассоциации, осознает значение\n" +
      "своих действий, имеет полное право на их совершение и полностью принимает условия\n" +
      "Оферты.</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>9.4. Во всем остальном, что\n" +
      "не установлено настоящей Офертой, стороны руководствуются действующим\n" +
      "законодательством РФ.</span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p  style='margin-bottom:0cm;margin-bottom:.0001pt;\n" +
      "text-align:center;line-height:normal;mso-layout-grid-align:none;text-autospace:\n" +
      "none'><b><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>10.\n" +
      "Реквизиты Ассоциации</span></b></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>Наименование: Некоммерческая организация «Ассоциация\n" +
      "малых туристских городов» Юридический / фактический адрес: РФ, 152615 Россия,\n" +
      "Ярославская область, г. Углич, ул. Ростовская, д.6</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>ИНН 7612038571</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>КПП 761201001</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>Электронный адрес: <a\n" +
      "href=\"mailto:info@amtg-rus.ru\"><span style='color:black;text-decoration:none;\n" +
      "text-underline:none'>info@amtg-rus.ru</span></a><br/>\n" +
      "Телефон: +7(980)744-92-09</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>Банковские реквизиты:</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>в Московский филиал &quot;БАНК СГБ&quot; г.\n" +
      "Москва </span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>Р/с 40703810719050000062</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>К/с 30101810245250000094</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'>БИК 044525094</span></p>\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:\n" +
      "normal;mso-layout-grid-align:none;text-autospace:none'><span style='font-size:\n" +
      "12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:TimesNewRomanPSMT;\n" +
      "color:black;mso-font-kerning:0pt'> </span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>Получатель: Некоммерческая\n" +
      "организация «Ассоциация малых туристских городов»</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>Назначение платежа:\n" +
      "Добровольное пожертвование на уставные цели и благотворительные проекты</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>в Московский филиал\n" +
      "&quot;БАНК СГБ&quot; г. Москва</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>р/с 40703810719050000062</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>ИНН получателя: 7612038571</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>БИК 044525094</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "><span><span style='font-size:12.0pt;font-family:TimesNewRomanPSMT;\n" +
      "mso-bidi-font-family:TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>кор.счет</span></span></span><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'> 30101810245250000094</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>КПП получателя: 761201001</span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>Получатель: Некоммерческая\n" +
      "организация Ассоциация малых туристских городов</span></p>\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'>Назначение платежа: Добровольное\n" +
      "пожертвование на уставные цели и проекты Ассоциации</span></p>\n" +
      "\n" +
      "\n" +
      "\n" +
      "\n" +
      "\n" +
      "\n" +
      "\n" +
      "<p style='margin-bottom:0cm;margin-bottom:.0001pt;text-align:\n" +
      "justify;line-height:normal;mso-layout-grid-align:none;text-autospace:none'><span\n" +
      "style='font-size:12.0pt;font-family:TimesNewRomanPSMT;mso-bidi-font-family:\n" +
      "TimesNewRomanPSMT;color:black;mso-font-kerning:0pt'><img src='fax.jpg' style='width: 200px;'/>Директор\n" +
      "____________________________ Анучин К.В.</span></p><img src='stamp.jpg' style='width: 250px;'/>\n" +
      "\n" +
      "\n" +
      "\n" +
      "</div>"
  }}>

  </Box>
]


let image: ImageInterface = {
  src: "/main.jpg",
  width: 2000,
  height: 1345
}

declare global {
  interface Window {
    paidCellsGlobal: any,
    moneyGlobal: number
    payPartGlobal: number
  }
}
let money = window.moneyGlobal
let payPart = window.payPartGlobal
let paidCells = window.paidCellsGlobal; // ok now


let mouseDown = false

export const formatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export default function ImageComp() {

  const [hovering, setHovering] = useState(null);
  const [selectedCells, setSelectedCells] = useState<{}>({});
  const [imageSrc, setImageSrc] = useState("");
  const [selectionState, setSelectionState] = useState("pen");
  const [selectionRadius, setSelectionRadius] = useState(1);
  const [zoomState, setZoomState] = useState(1);
  const imageBox = useRef(null);

  let cells = money / payPart
  let rows = Math.sqrt(cells)
  let cellW = image.width / rows
  let cellH = image.height / rows


  const getPaidCellsCount = () => {
    let count = 0
    Object.keys(paidCells).map(row => {
      let cols = paidCells[row]
      count += Object.keys(cols).length
    })

    return count * payPart;
  }

  const getRatioPositive = () => {
    if (imageBox.current) {

      return imageBox.current.naturalWidth / imageBox.current.offsetWidth
    }

    return 1
  }
  const getRatioNegative = () => {
    if (imageBox.current) {

      return imageBox.current.offsetWidth / imageBox.current.naturalWidth
    }

    return 1
  }

  function getRationedPosition(e) {
    let ratio = getRatioPositive()

    let rect = e.target.getBoundingClientRect();

    let clientX = e.clientX ? e.clientX : e.touches[0].clientX
    let clientY = e.clientY ? e.clientY : e.touches[0].clientY

    let x = Math.floor((clientX - rect.left) * ratio / zoomState); //x position within the element.
    let y = Math.floor((clientY - rect.top) * ratio / zoomState);

    return {x: x, y: y}
  }

  const handleMouseOver = (e) => {

    let windowedWidth = e.target.parentNode.parentNode.offsetWidth
    let windowedHeight = e.target.parentNode.parentNode.offsetHeight
    let imageWidth = windowedWidth * zoomState
    let imageHeight = windowedHeight * zoomState
    let clientX = e.clientX ? e.clientX : e.touches[0].clientX
    let clientY = e.clientY ? e.clientY : e.touches[0].clientY

    let rect = e.target.parentNode.parentNode.getBoundingClientRect();
    let x = Math.floor((clientX - rect.left)); //x position within the element.
    let y = Math.floor((clientY - rect.top));

    let posCenterX = (windowedWidth / 2 - x)
    let posCenterY = (windowedHeight / 2 - y)

    let aspectPosX = windowedWidth / 2 / posCenterX
    let aspectPosY = windowedHeight / 2 / posCenterY

    let tx = (imageWidth - windowedWidth) / 2 / zoomState / aspectPosX
    let ty = (imageHeight - windowedHeight) / 2 / zoomState / aspectPosY


    e.target.parentNode.style.transform = `scale(${zoomState}) translate(${tx}px, ${ty}px)`;

    if (mouseDown) {
      selectCell(e)
    }


    if (isPixelPaid(y * image.width + x)) {
      if (hovering === null) {
        let newAr = [];
        newAr.push(e.clientY)
        newAr.push(e.clientX)
        setHovering(newAr);
      }
    } else {
      if (hovering !== null) {
        setHovering(null);
      }
    }
  };
  const handleMouseOut = () => {
    setHovering(null);
  };

  const selectCellWithRadiusPen = (row, col, newSelectedCells) => {

    let radLeft = 0
    let radRight = 0
    if (selectionRadius == 1) {
      radLeft = 1
    }
    if (selectionRadius == 2) {
      radLeft = 1
      radRight = 1
    }

    for (let i = -1 * radLeft; i <= radRight; i += 1) {
      let rowCurrent = row + i
      if (rowCurrent >= 0 && rowCurrent <= rows - 1) {
        if (!newSelectedCells[rowCurrent]) {
          newSelectedCells[rowCurrent] = {}
        }

        for (let f = -1 * radLeft; f <= radRight; f += 1) {
          let colCurrent = col + f
          if (colCurrent >= 0 && colCurrent <= rows - 1) {
            if (!paidCells || !paidCells[rowCurrent] || !paidCells[rowCurrent][colCurrent]) {
              newSelectedCells[rowCurrent][colCurrent] = true
            }


          }
        }
      }
    }

    setSelectedCells(newSelectedCells)
  }

  const selectCellWithRadiusErase = (row, col, newSelectedCells) => {

    for (let i = -1 * selectionRadius; i <= selectionRadius; i += 1) {
      let rowCurrent = row + i
      if (newSelectedCells[rowCurrent]) {
        for (let f = -1 * selectionRadius; f <= selectionRadius; f += 1) {
          let colCurrent = col + f

          if (newSelectedCells[rowCurrent][colCurrent]) {
            delete newSelectedCells[rowCurrent][colCurrent]

            setSelectedCells(newSelectedCells)
          }

        }
      }

    }

  }


  const selectCell = (e) => {

    let newSelectedCells = {...selectedCells}

    let {x, y} = getRationedPosition(e)
    let {col, row} = getCellPos(y * image.width + x)

    if (paidCells[row] && paidCells[row][col]) {
      return
    }

    if (selectionState === "pen") {
      selectCellWithRadiusPen(row, col, newSelectedCells)
    } else {

      selectCellWithRadiusErase(row, col, newSelectedCells)
    }


  };

  function getCellPos(pixel) {
    let rowNumPixel = Math.floor(pixel / image.width)
    let rowNum = Math.floor(rowNumPixel / cellH)
    let cellNum = Math.floor((pixel - (rowNumPixel * image.width)) / cellW)

    return {col: cellNum, row: rowNum}
  }

  const isPixelPaid = (pixel) => {
    let {col, row} = getCellPos(pixel)

    return paidCells[row] && paidCells[row][col]
  }


  useEffect(() => {


    const canvas = document.createElement('canvas')
    canvas.height = image.height
    canvas.width = image.width

    const ctx = canvas.getContext("2d");
    const pixels = new Uint8ClampedArray(image.height * image.width * 4);


// Fill the array with the same RGBA values
    let pixel = 0
    for (let i = 0; i < pixels.length; i += 4) {

      if (pixel % cellW === 0) {
        pixels[i + 0] = 100; // R value
        pixels[i + 1] = 100; // G value
        pixels[i + 2] = 100; // B value
        pixels[i + 3] = 100; // A value
      } else if (Math.floor(pixel / image.width) % cellH === 0) {
        pixels[i + 0] = 100; // R value
        pixels[i + 1] = 100; // G value
        pixels[i + 2] = 100; // B value
        pixels[i + 3] = 100; // A value
      } else {

        if (isPixelPaid(pixel)) {
          pixels[i + 0] = 0; // R value
          pixels[i + 1] = 0; // G value
          pixels[i + 2] = 0; // B value
          pixels[i + 3] = 0; // A value
        } else {
          pixels[i + 0] = 255; // R value
          pixels[i + 1] = 255; // G value
          pixels[i + 2] = 255; // B value
          pixels[i + 3] = 120; // A value
        }


      }

      pixel = pixel + 1
    }

// Initialize a new ImageData object
    let imageData = new ImageData(pixels, image.width, image.height);

// Draw image data to the canvas
    ctx.putImageData(imageData, 0, 0);

    setImageSrc(canvas.toDataURL('image/png'));
  }, [])

  let ratio = getRatioNegative()


  let selectedCount = 0
  Object.keys(selectedCells).map(row => {
    let cols = selectedCells[row]
    selectedCount += Object.keys(cols).length
  })


  const showMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  return <>
    <Box sx={{backgroundColor: "#54c0c9", px: {xs: 4, sm: 6, md: 6}, pb: 12}}>
      <Box py={2}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={3}>
            <DialogComp head={"О проекте"} text={texts[0]}/>
          </Grid>
          <Grid item xs={6} md={3}>
            <DialogComp head={"Механика"} text={texts[1]}/>
          </Grid>
          <Grid item xs={6} md={3}>
            <DialogComp head={"Финансы"} text={texts[2]}/>
          </Grid>
          <Grid item xs={6} md={3}>
            <DialogComp head={"Договор"} text={texts[3]}/>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={4}>

        <Grid item xs={12} lg={7}>
          <Box sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative"
          }}>
            <Box sx={{position: "relative"}}>
              <div className="bg__frame">
                <div className="bg__picture-wrapper">
                  <div className="bg__frame-inner-shadow-outer">
                    <div className="bg__frame-inner-shadow"/>
                  </div>
                  <div className="bg__frame-inner-shine-outer">
                    <div className="bg__frame-inner-shine"/>
                  </div>
                  <div className="bg__frame-inner-photo-shadow-outer">
                    <div className="bg__frame-inner-photo-shadow"/>
                  </div>

                  <Box sx={{overflow: "hidden"}}>
                    <Box sx={{
                      zIndex: 9,
                      display: "flex",
                      backgroundImage: "url(" + image.src + ")",
                      backgroundSize: "cover",
                      position: "relative",
                      userSelect: "none",
                      touchAction: "pinch-zoom",
                    }}
                         style={{transform: "scale(" + zoomState + ")"}}
                    >


                      <img src={imageSrc} alt={""} width={image.width} height={image.height} ref={imageBox}
                           style={{width: "100%", height: "100%"}}


                      />
                      <Box sx={{position: "absolute", top: 0, left: 0, bottom: 0, right: 0}}>
                        {Object.keys(selectedCells).map(row => {
                          let cols = selectedCells[row]
                          return Object.keys(cols).map(cell => {
                            return <Box sx={{
                              width: cellW * ratio,
                              height: cellH * ratio,
                              top: parseInt(row) * cellH * ratio,
                              left: parseInt(cell) * cellW * ratio,
                              backgroundColor: "rgba(255,0,0,0.31)",
                              position: "absolute"
                            }}/>
                          })
                        })}
                      </Box>

                      <Box sx={{position: "absolute", top: 0, left: 0, bottom: 0, right: 0}}
                           onMouseMove={handleMouseOver}
                           onTouchMove={handleMouseOver}
                           onMouseOut={handleMouseOut}
                           onMouseDown={(e) => {
                             mouseDown = true
                             selectCell(e)
                           }}
                           onTouchStart={(e) => {
                             mouseDown = true
                             selectCell(e)
                           }}
                           onMouseUp={(e) => {
                             mouseDown = false
                           }}
                      />

                    </Box>


                    <Box>
                      <Popper sx={{zIndex: 99}} transition anchorEl={
                        hovering != null && hovering.length > 0 ?
                          {
                            getBoundingClientRect: () => ({
                              width: 0,
                              height: 0,
                              left: hovering[1],
                              top: hovering[0],
                              x: null, y: null, bottom: null, right: null, toJSON: null
                            })
                          }
                          :
                          null
                      }
                              open={hovering != null && hovering.length > 0}
                              placement="top-start"
                      >
                        {({TransitionProps}) => (
                          <Fade {...TransitionProps} timeout={350}>
                            <Box sx={{border: 1, p: 1, bgcolor: 'background.paper',}}>
                              Средства собраны
                            </Box>
                          </Fade>
                        )}
                      </Popper>
                    </Box>
                  </Box>
                </div>
              </div>

              <Box mt={2} >
                <Box mb={2} sx={{textAlign: "center"}}>
                  <Button
                    color="secondary"
                    variant={"contained"}
                    onClick={() => setSelectedCells({})}
                    startIcon={<Cancel/>}
                    disabled={selectedCount === 0}
                  >
                    Сбросить
                  </Button>
                </Box>
                <Grid container spacing={3}>

                  <Grid item xs={12} sm={5}>
                    <Box sx={{width: "100%"}}>
                      <SelectSettings selectionState={selectionState} setSelectionState={setSelectionState}
                                      radius={selectionRadius} setRadius={setSelectionRadius}/>

                      <Box>
                        <Typography color={"white"} variant={"h5"} sx={{fontWeight: "bold", textAlign: "center"}}>
                          Размер выделяемой ячейки
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={0} sm={2}>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <Box sx={{width: "100%"}}>
                      <ZoomSettings zoomState={zoomState} setZoomState={setZoomState}/>
                      <Box>
                        <Typography color={"white"} variant={"h5"} sx={{fontWeight: "bold", textAlign: "center"}}>
                          Увеличить изображение
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>


              </Box>

            </Box>
          </Box>


        </Grid>

        <Grid item xs={12} lg={5}>
          <Box mt={9}>

            <Box mb={4} mt={2}>
              <Typography color={"white"} variant={"h3"} sx={{fontWeight: "bold"}} mt={2}>
                Общая сумма - {formatter.format(money)}
              </Typography>

              <Typography color={"white"} variant={"h3"} sx={{fontWeight: "bold"}} mt={2}>
                Собрано - {formatter.format(getPaidCellsCount())}
              </Typography>
            </Box>


            <Box mt={6}>
              <Typography color={"white"} variant={"h3"} sx={{fontWeight: "bold"}} mt={2}>
                Выделено ячеек - <Typography variant={"h3"} component={"span"}
                                             sx={{color: "yellow", fontWeight: "bold"}}>{selectedCount}</Typography>
              </Typography>
              <Typography color={"white"} variant={"h3"} sx={{fontWeight: "bold"}} mt={2}>
                На общую сумму - <Typography variant={"h3"} component={"span"} sx={{
                color: "yellow",
                fontWeight: "bold"
              }}>{formatter.format(selectedCount * payPart)}</Typography>
              </Typography>
            </Box>
            <Box mr={2} mt={6}>

              <PayComp selectedCells={selectedCells}/>


            </Box>
          </Box>

        </Grid>

      </Grid>
    </Box>

    <Global
      styles={css`


.bg__picture {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bg__picture-wrapper {
  width: 100%;
  height: 100%;
  padding-top: 48px;
  padding-bottom: 48px;
  padding-left: 52px;
  padding-right: 52px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.bg__frame-inner-shadow-outer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  z-index: 9;
  position: absolute;
  box-sizing: border-box;
}

.bg__frame-inner-shadow {
  width: 100%;
  height: 100%;
  -webkit-box-shadow: inset 6px 8px 16px -8px #000001;
  -moz-box-shadow: inset 68px 8px 16px -8px #000001;
  box-shadow: inset 6px 8px 16px -8px #000001;
  opacity: 0.6;
}

.bg__frame-inner-shine-outer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  z-index: 9;
  position: absolute;
  box-sizing: border-box;
}

.bg__frame-inner-shine {
  width: 100%;
  height: 100%;
  -webkit-box-shadow: inset -48px -8px 58px -14px #212121;
  -moz-box-shadow: inset -4px -8px 58px -14px #212121;
  box-shadow: inset -4px -8px 58px -14px #212121;
  opacity: 0.4;
}

.bg__frame-inner-photo-shadow-outer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding-top: 48px;
  padding-bottom: 48px;
  padding-left: 52px;
  padding-right: 52px;
  z-index: 9;
  position: absolute;
  box-sizing: border-box;
}

.bg__frame-inner-photo-shadow {
  width: 100%;
  height: 100%;
  -webkit-box-shadow: inset -2px 1px 12px -1px #212121;
  -moz-box-shadow: inset -2px -1px 12px -1px #212121;
  box-shadow: inset -2px -1px 12px -1px #212121;
  opacity: 0.2;
}

.bg__frame {
box-sizing: border-box;
  background-color: #eceff1;

  border: 1px solid;
  border-color: rgba(33, 33, 33, 0.9) rgba(33, 33, 33, 0.9);
  box-shadow: 3px 6px 10px -2px rgba(0, 0, 0, 0.3), inset 0 1px 0 #212121, inset 1px 0 0 #232323, inset 0 -1px 0 #212121, inset -1px 0 0 #232323, inset 0 2px 0 #242425, inset 2px 0 0 #262728, inset 0 -2px 0 #242425, inset -2px 0 0 #262728, inset 0 3px 0 #26272a, inset 3px 0 0 #24252c, inset 0 -3px 0 #26272a, inset -3px 0 0 #24252c, inset 0 4px 0 #292a2e, inset 4px 0 0 #2e2e31, inset 0 -4px 0 #292a2e, inset -4px 0 0 #2e2e31, inset 0 5px 0 #2b2c33, inset 5px 0 0 #313235, inset 0 -5px 0 #2b2c33, inset -5px 0 0 #313235, inset 0 6px 0 #2e2f37, inset 6px 0 0 #353539, inset 0 -6px 0 #2e2f37, inset -6px 0 0 #353539, inset 0 7px 0 #30323c, inset 7px 0 0 #38393e, inset 0 -7px 0 #30323c, inset -7px 0 0 #38393e, inset 0 8px 0 #333540, inset 8px 0 0 #3c3d42, inset 0 -8px 0 #333540, inset -8px 0 0 #3c3d42, inset 0 9px 0 #353844, inset 9px 0 0 #3f4147, inset 0 -9px 0 #353844, inset -9px 0 0 #3f4147, inset 0 10px 0 #383b49, inset 10px 0 0 #43444b, inset 0 -10px 0 #383b49, inset -10px 0 0 #43444b, inset 0 11px 0 #3a3d4d, inset 11px 0 0 #474850, inset 0 -11px 0 #3a3d4d, inset -11px 0 0 #474850, inset 0 12px 0 #3d4052, inset 12px 0 0 #4a4c54, inset 0 -12px 0 #3d4052, inset -12px 0 0 #4a4c54, inset 0 13px 0 #3f4356, inset 13px 0 0 #4a4c54, inset 0 -13px 0 #3f4356, inset -13px 0 0 #4a4c54, inset 0 14px 0 #3d4052, inset 14px 0 0 #474850, inset 0 -14px 0 #3d4052, inset -14px 0 0 #474850, inset 0 15px 0 #3a3d4d, inset 15px 0 0 #43444b, inset 0 -15px 0 #3a3d4d, inset -15px 0 0 #43444b, inset 0 16px 0 #383b49, inset 16px 0 0 #3f4147, inset 0 -16px 0 #383b49, inset -16px 0 0 #3f4147;
}
      `}
    />
  </>
}





